var i = 256, f = [], n;
for (; i--; ) f[i] = (i + 256).toString(16).substring(1);
function o() {
  var r = 0, t, e = "";
  if (!n || i + 16 > 256) {
    for (n = Array(r = 256); r--; ) n[r] = 256 * Math.random() | 0;
    r = i = 0;
  }
  for (; r < 16; r++)
    t = n[i + r], r == 6 ? e += f[t & 15 | 64] : r == 8 ? e += f[t & 63 | 128] : e += f[t], r & 1 && r > 1 && r < 11 && (e += "-");
  return i++, e;
}
export {
  o as v4
};
//# sourceMappingURL=index44.js.map
